export default {
  // 登陆鉴权，获取aid和token
  LOGIN: '/v1/interface/inner/cloudim_324034',
  // 退出排队
  EXIT_QUEUE: '/v1/interface/inner/txplus_214001',
  // 下载被压缩的长文本或xml
  DOWNLOAD_COMPRESSED_COTENT: '/interface/inner/cloudcc_303902',
}